//import React, { useState } from "react";
import { Controller } from "react-hook-form";
const TextAreaField = ({
  label,
  value = "",
  onChange,
  error,
  required,
  control,
  name,
  defaultValue = "",
  ...props
}) => {
  // const [showPassword, setShowPassword] = useState(false);

  return (
    <div className={`form__group ${error && "error"}`}>
      <label>
        {label}
        {required && <span>*</span>}
      </label>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ field }) => (
          <div className="form__input">
            <textarea
              {...field}
              value={field.value}
              onChange={field.onChange}
              {...props}
            />
          </div>
        )}
      />
      {error && <span className="form__error">{error}</span>}
    </div>
  );
};

export default TextAreaField;
